import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Seo } from "@/components/site/Seo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <Seo title="Owner Login | Escamequita" description="Admin login" noindex />
      <div className="relative hidden lg:block">
        <img src="/media/cielo-cover.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/40" />
        <p className="absolute bottom-12 left-12 font-logo text-6xl font-black text-white">Escamequita</p>
      </div>
      <div className="flex items-center justify-center bg-linen p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 rounded-2xl border border-clay bg-white p-8" data-testid="admin-login-form">
          <div>
            <p className="eyebrow">Owner dashboard</p>
            <h1 className="mt-2 text-3xl font-black text-forest">Sign in</h1>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email" className="font-bold">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12" data-testid="admin-login-email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="font-bold">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" data-testid="admin-login-password" />
          </div>
          {error && <p className="text-sm font-semibold text-destructive" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-login-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
